import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/index';
import Title from '../Title/index';
import { RentBuyCardStyled, BottomPart, StyledText, TopPart } from './styles/RentBuyCardStyled';

const RentBuyCard = ({ title, price, text, onClick }) => (
  <RentBuyCardStyled onClick={onClick}>
    <TopPart>
      <Title font="din_medium" color="gray_nightrider">
        {title}
      </Title>
      <Text size="fs_s">{price}</Text>
    </TopPart>
    <BottomPart>
      <StyledText tag="p" size="fs_xs" color="gray">
        {text}
      </StyledText>
    </BottomPart>
  </RentBuyCardStyled>
);

RentBuyCard.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default memo(RentBuyCard);
